import { Link } from '@mui/material'
import { C1IconButton } from 'c1ui'
import { C1DrawerInner } from 'components/core/drawer/C1DrawerInner'
import { C1Icon } from 'components/core/icons/C1Icon'
import { getDisplayAlert } from 'components/pages/explore/inventory/alert-util'
import { ArrowLeft, X } from 'lucide-react'
import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { HistoricalInventoryAlertValue, InventoryAlertValue } from 'redux_toolkit/apps'
import { InventoryAlertDetails } from './InventoryAlertDetails'

type InventoryAlertDrawerProps = {
    expandedAlert: InventoryAlertValue | HistoricalInventoryAlertValue,
    closeDrawer: () => void,
    showList: () => void,
}

export const InventoryAlertDrawer = ({ expandedAlert, closeDrawer, showList }: InventoryAlertDrawerProps): ReactElement => {
    const intl = useIntl()

    const alert = getDisplayAlert(intl, expandedAlert)
    if (!alert) {
        return <></>
    }

    return <C1DrawerInner>
        <C1DrawerInner.Header actions={<C1IconButton
            onClick={closeDrawer}
            size="small"
            sx={{ ml: 'auto' }}
            aria-label={intl.formatMessage({
                id: 'components_inventory_alert_drawer_close',
                defaultMessage: 'Close alert details',
            })}
        >
            <C1Icon icon={X} size="sm" />
        </C1IconButton>}
        >
            <Link
                onClick={showList}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.primary',
                    textDecoration: 'none',
                    pt: 2,
                }}
            >
                <C1Icon icon={ArrowLeft} size="sm" sx={{ mr: 1 }} />
                <FormattedMessage id="all_alerts" defaultMessage="Back to alerts" />
            </Link>
        </C1DrawerInner.Header>
        <C1DrawerInner.Content>
            <InventoryAlertDetails expandedAlert={expandedAlert} />
        </C1DrawerInner.Content>
    </C1DrawerInner>
}
